import * as tslib_1 from "tslib";
import { Location } from '@angular/common';
import { OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChartDateIntervalSelectorMapperService } from '@core/components/charts/chart-date-interval-selector/services/chart-date-interval-selector.mapper.service';
import { STATUS_NAMES_DONE, STATUS_NAMES_EXCEPT_CANCELED, STATUS_NAMES_EXCEPT_CANCELED_AND_DONE } from '@core/consts';
import { SidenavService } from '@core/services/sidenav.service';
import { endOfDay, mapIds, startOfDay } from '@core/utils/filters-utils';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { isEqual, sumBy } from 'lodash';
import moment from 'moment';
import { merge, Subject } from 'rxjs';
import { debounceTime, filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { sentry } from 'sentry';
import { delay } from '../../../core/utils/delay';
import { VolumetryService } from './api/queries.service';
import { FilterComponent } from './filter/filter.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var VolumetryComponent = /** @class */ (function () {
    function VolumetryComponent(chartDateIntervalSelectorMapperService, fuseTranslationLoaderService, fuseProgressBarService, volumetryService, sidenavService, router, location) {
        this.chartDateIntervalSelectorMapperService = chartDateIntervalSelectorMapperService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.volumetryService = volumetryService;
        this.sidenavService = sidenavService;
        this.router = router;
        this.location = location;
        this.isLoading = true;
        this.isLoadingOnlyLineChart = true;
        this.subscriptions = new Subject();
        this.reloadEvent = new Subject();
        this.autoReloadTime = 5000;
        this.charts = {
            types: {
                items: [],
            },
            segments: {
                items: [],
            },
            topPendingTime: {
                items: [],
            },
            pendingTimePerInterval: {
                items: [],
                total: 0
            },
            maintenanceCompletedByApplication: {
                items: []
            },
        };
        this.maintenanceCompletedTimeline = [];
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    VolumetryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.autoRefresh({ checked: false });
        merge(this.filter.filterForm.valueChanges, this.reloadEvent).pipe(takeUntil(this.subscriptions), filter(function () { return _this.filter.filterForm.valid; }), tap(function () { return _this.isLoading = true; }), debounceTime(500))
            .pipe(switchMap(function () { return _this.updateData(); }))
            .pipe(tap(function () {
            _this.isLoading = false;
            _this.isLoadingOnlyLineChart = false;
        }))
            .subscribe(function () {
            _this.isFilterOn = !isEqual(_this.filter.filterForm.value, _this.filter.defaultFilterValue);
            _this.checkIfThereIsData();
        });
        this.reload();
        this.checkIfThereIsData();
    };
    VolumetryComponent.prototype.ngOnDestroy = function () {
        clearInterval(this.intervalId);
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    VolumetryComponent.prototype.getDateLineChartDateInterval = function (dateInterval) {
        this.lastOpenedAtResponse = dateInterval;
        if (this.filter.filterForm.invalid || !this.lineChartData) {
            return;
        }
        this.updateLineChartData();
    };
    VolumetryComponent.prototype.updateData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var where, _a, accountMaintenancesSegments, accountMaintenancesTypes, accountMaintenancesPendingTimeInterval, accountMaintenancesTopPendingTime, accountMaintenancesCompletedBySources, accountMaintenancesCompletedTimeline, maintenanceCompletedTimeline, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.fuseProgressBarService.show();
                        where = this.toQuery(this.filter.filterForm.value);
                        return [4 /*yield*/, Promise.all([
                                this.volumetryService.accountMaintenancesSegments(where),
                                this.volumetryService.accountMaintenancesTypes(where),
                                this.volumetryService.accountMaintenancesPendingTimeInterval(where),
                                this.volumetryService.accountMaintenancesTopPendingTime(where),
                                this.volumetryService.accountMaintenancesCompletedBySources(where),
                                this.volumetryService.accountMaintenancesCompletedLineChart(where),
                                delay(700)
                            ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 6]), accountMaintenancesSegments = _a[0], accountMaintenancesTypes = _a[1], accountMaintenancesPendingTimeInterval = _a[2], accountMaintenancesTopPendingTime = _a[3], accountMaintenancesCompletedBySources = _a[4], accountMaintenancesCompletedTimeline = _a[5];
                        this.charts.segments.items = accountMaintenancesSegments;
                        this.charts.pendingTimePerInterval.items = accountMaintenancesPendingTimeInterval;
                        this.charts.types.items = accountMaintenancesTypes;
                        this.charts.pendingTimePerInterval.total = sumBy(accountMaintenancesPendingTimeInterval, 'value');
                        this.charts.topPendingTime.items = accountMaintenancesTopPendingTime;
                        this.charts.maintenanceCompletedByApplication.items = accountMaintenancesCompletedBySources;
                        this.lineChartData = accountMaintenancesCompletedTimeline;
                        maintenanceCompletedTimeline = [this.chartDateIntervalSelectorMapperService.toLineChartFormat(accountMaintenancesCompletedTimeline, this.lastOpenedAtResponse)];
                        this.maintenanceCompletedTimeline = this.mapLineChartData(maintenanceCompletedTimeline);
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _b.sent();
                        console.error(err_1);
                        sentry.captureException(err_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VolumetryComponent.prototype.toQuery = function (value) {
        return {
            locationGroupId_in: mapIds(value.locationGroups),
            locationId_in: mapIds(value.locations),
            typeId_in: mapIds(value.maintenanceTypes),
            segmentId_in: mapIds(value.segments),
            companyId_in: mapIds(value.companies),
            from: startOfDay(value.openedAtGte),
            to: endOfDay(value.openedAtLte),
            scheduledAt_gte: startOfDay(value.scheduledAtGte, 'YYYY-MM-DD'),
            scheduledAt_lte: endOfDay(value.scheduledAtLte, 'YYYY-MM-DD'),
            closedAt_gte: startOfDay(value.closedAtGte),
            closedAt_lte: endOfDay(value.closedAtLte),
        };
    };
    VolumetryComponent.prototype.autoRefresh = function (event) {
        var _this = this;
        if (event.checked) {
            this.intervalId = setInterval(function () { return _this.reloadEvent.next(); }, this.autoReloadTime);
        }
        else {
            clearInterval(this.intervalId);
        }
    };
    VolumetryComponent.prototype.updateLineChartData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenanceCompletedTimeline, err_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.isLoadingOnlyLineChart = true;
                        return [4 /*yield*/, delay(300)];
                    case 1:
                        _a.sent();
                        maintenanceCompletedTimeline = [this.chartDateIntervalSelectorMapperService.toLineChartFormat(this.lineChartData, this.lastOpenedAtResponse)];
                        this.maintenanceCompletedTimeline = this.mapLineChartData(maintenanceCompletedTimeline);
                        this.checkIfThereIsData();
                        return [3 /*break*/, 4];
                    case 2:
                        err_2 = _a.sent();
                        sentry.captureException(err_2);
                        return [3 /*break*/, 4];
                    case 3:
                        this.isLoadingOnlyLineChart = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VolumetryComponent.prototype.checkIfThereIsData = function () {
        var _this = this;
        this.maintenanceCompletedTimeline.forEach(function (item) {
            if (item.series && item.series.length) {
                _this.hasData = item.series.some(function (serie) { return serie.value !== 0; });
            }
        });
    };
    VolumetryComponent.prototype.openSidenav = function () {
        this.sidenavService.open('filterDashboard');
    };
    VolumetryComponent.prototype.reload = function () {
        this.reloadEvent.next();
    };
    VolumetryComponent.prototype.clearFilters = function () {
        this.filter.filterForm.patchValue(this.filter.defaultFilterValue);
    };
    VolumetryComponent.prototype.yAxisFormatToInteger = function (val) {
        if (val % 1 > 0) {
            return '';
        }
        return val;
    };
    VolumetryComponent.prototype.onSelectSegment = function (event) {
        var queryParams = this.toMaintenancePageQueryParams();
        queryParams.segmentId_in = event.extra.segment.id;
        queryParams.status_in = STATUS_NAMES_EXCEPT_CANCELED.join();
        var urlTree = this.router.createUrlTree(['manutencoes'], { queryParams: queryParams });
        var url = this.router.serializeUrl(urlTree);
        window.open(this.location.prepareExternalUrl(url), '_blank');
    };
    VolumetryComponent.prototype.onSelectMaintenanceType = function (event) {
        var queryParams = this.toMaintenancePageQueryParams();
        queryParams.typeId_in = event.extra.maintenanceType.id;
        queryParams.status_in = STATUS_NAMES_EXCEPT_CANCELED.join();
        var urlTree = this.router.createUrlTree(['manutencoes'], { queryParams: queryParams });
        var url = this.router.serializeUrl(urlTree);
        window.open(this.location.prepareExternalUrl(url), '_blank');
    };
    VolumetryComponent.prototype.onSelectPendingTimePerInterval = function (event) {
        var queryParams = this.toMaintenancePageQueryParams();
        queryParams.status_in = STATUS_NAMES_EXCEPT_CANCELED_AND_DONE.join();
        queryParams.openedAt_gte = moment(event.extra.openedAtMin).format();
        queryParams.openedAt_lte = moment(event.extra.openedAtMax).format();
        var urlTree = this.router.createUrlTree(['manutencoes'], { queryParams: queryParams });
        var url = this.router.serializeUrl(urlTree);
        window.open(this.location.prepareExternalUrl(url), '_blank');
    };
    VolumetryComponent.prototype.onSelectTopPendingPerInterval = function (event) {
        var queryParams = this.toMaintenancePageQueryParams();
        queryParams.number_contains = event.extra.maintenance.number;
        var urlTree = this.router.createUrlTree(['manutencoes'], { queryParams: queryParams });
        var url = this.router.serializeUrl(urlTree);
        window.open(this.location.prepareExternalUrl(url), '_blank');
    };
    VolumetryComponent.prototype.onSelectMaintenanceCompletedTimeline = function (event) {
        var queryParams = this.toQuery(this.filter.filterForm.value);
        queryParams.openedAt_gte = queryParams.from;
        queryParams.openedAt_lte = queryParams.to;
        delete queryParams.from;
        delete queryParams.to;
        queryParams.status_in = STATUS_NAMES_DONE.join();
        queryParams.closedAt_gte = moment(event.initialDate).startOf('day').format();
        queryParams.closedAt_lte = moment(event.finalDate).endOf('day').format();
        var urlTree = this.router.createUrlTree(['manutencoes'], { queryParams: queryParams });
        var url = this.router.serializeUrl(urlTree);
        window.open(this.location.prepareExternalUrl(url), '_blank');
    };
    VolumetryComponent.prototype.mapLineChartData = function (data) {
        if (!data) {
            return [];
        }
        return data.map(function (item) {
            return tslib_1.__assign({}, item, { series: item.series.map(function (_a) {
                    var totalCount = _a.totalCount, seriesItem = tslib_1.__rest(_a, ["totalCount"]);
                    return tslib_1.__assign({}, seriesItem, { value: totalCount });
                }) });
        });
    };
    VolumetryComponent.prototype.toMaintenancePageQueryParams = function () {
        var _a = this.toQuery(this.filter.filterForm.value), openedAt_gte = _a.from, openedAt_lte = _a.to, locationsGroupsId_in = _a.locationGroupId_in, rest = tslib_1.__rest(_a, ["from", "to", "locationGroupId_in"]);
        return tslib_1.__assign({}, rest, { openedAt_gte: openedAt_gte,
            openedAt_lte: openedAt_lte,
            locationsGroupsId_in: locationsGroupsId_in });
    };
    return VolumetryComponent;
}());
export { VolumetryComponent };
